import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NotificationEffects } from './notification.effects';
import * as fromNotification from './notification.reducer';
import * as fromNotificationState from './notification.state';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromNotificationState.notificationFeatureKey, fromNotification.reducer),
    EffectsModule.forFeature([NotificationEffects])
  ],
  declarations: []
})
export class NotificationStateModule {}
